import { occBaseSiteUrl } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";

export function checkoutAddressUrl(activeCartId: string, path: string): string {
  if (!activeCartId) {
    throw new Error("Cannot update a checkout address without an Active Cart ID");
  }
  return occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}${path}`);
}
